const CreateAssetType = Object.freeze({
  EQUITY: "EQUITY",
  EXCHANGE_TRADED_FUND: "EXCHANGE_TRADED_FUND",
  DEBT_SECURITY: "DEBT_SECURITY",
});

export default CreateAssetType;
